import { useEffect } from 'react';
import { useRouter } from 'next/router';

export default function useCloseOnRouteChange(setOpen) {
  const router = useRouter();

  useEffect(() => {
    const handleRouteChange = () => {
      setOpen(false);
    };

    router.events.on('routeChangeComplete', handleRouteChange);

    return () => {
      router.events.off('routeChangeComplete', handleRouteChange);
    };
  }, [router.events, setOpen]);
}
